import App from '@/App';
import Login from '@/router/views/Login';

import Home from '@/router/views/Home/Listar';
import DetalharProposta from '@/router/views/Propostas/Detalhar';
import ListarApolices from '@/router/views/Apolices/Listar';

import TermosDeServico from '@/router/views/TermosDeServico';

export default [
  {
    path: '/',
    name: 'ConnectionGuard',

    beforeEnter: (to, from, next) => {
      localStorage.clear();
      next({ name: 'Login' });
    },
  },

  { path: '/login/:debugFlag?', name: 'Login', component: Login },

  {
    path: '/home',
    name: 'Portal do Tomador',
    component: Home,
    meta: { authRequired: true },
  },

  {
    path: '/apolices-tomador/:documento',
    name: 'Apólices',
    component: ListarApolices,
    meta: { authRequired: true },
  },

  {
    path: '/termos-de-servico',
    name: 'Termos de Serviço',
    component: TermosDeServico,
    meta: { authRequired: true },
  },

  {
    path: '/proposta/:propostaId/:produtoId',
    name: 'Detalhes da Proposta',
    component: DetalharProposta,
    meta: { authRequired: true },
    props: true,
  },
  
];



// WEBPACK FOOTER //
// ./src/router/routes.js